import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiBarbieDollConfig } from '@/data/landingConfig/landingAiBarbieDollConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiBarbieDoll } from './schemaObject';

interface Props {}
const AiBarbieDoll: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiBarbieDoll} />
			<LandingTemplate
				data={landingAiBarbieDollConfig}
				funnelLinkService={GenerateLandingLinkService.funnelCartoonGenerator()}
			/>
		</>
	);
};

export default AiBarbieDoll;
